export const container = 'my-2';
export const labelStyle = 'text-sm font-semibold';
export const inputHidden = 'hidden';
export const labelContainer = 'flex flex-col items-center';
export const iconStyle = 'h-8 w-8 mb-2';
export const textStyle = 'text-sm';
export const textBold = 'font-semibold';
export const subTextStyle = 'text-xs';
export const fileInfo = 'mt-2 flex flex-col items-center';
export const fileName = 'text-sm text-gray-700';
export const previewImage = 'mt-2 w-32 h-32 object-contain';
export const removeButton = 'mt-2 p-2 bg-red-500 text-white rounded hover:bg-red-700';

